const inboxOptions = [
 { value: 'Inbox', label: 'Inbox' },
 { value: 'Study Team Contacted', label: 'Study Team Contacted' },
 { value: 'Patient Contacted', label: 'Patient Contacted' },
 { value: 'Pre Screen Pass', label: 'Pre Screen Pass' },
 { value: 'Pre Screen Fail', label: 'Pre Screen Fail' },
 { value: 'Enrolled', label: 'Enrolled' },
 { value: 'No PI Contact', label: 'No PI Contact' },
 { value: 'No Patient Contact', label: 'No Patient Contact' },
 { value: 'Exported', label: 'Exported' },
 { value: 'Deleted', label: 'Archive' }
]
const studyPhase = [
  { value: 'Phase 1', label: 'Phase 1' },
  { value: 'Phase 2', label: 'Phase 2' },
  { value: 'Phase 3', label: 'Phase 3' },
  { value: 'Phase 4', label: 'Phase 4' },
  { value: 'N/A', label: 'N/A' }
]
const studyType = [
  { value: 'Interventional', label: 'Interventional' },
  { value: 'Observational', label: 'Observational' }
]
const gender = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'All', label: 'All' }
]
const genderPatient = [
  {value: 'M', label: 'Male'},
  {value: 'F', label: 'Female'}
]
const healthy = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
]
const trialStatus = [
  { value: 'Active(Enrolling)', label: 'Active(Enrolling)' },
  { value: 'Inactive(Not Enrolling)', label: 'Inactive(Not Enrolling)' }
]
const instances = [
  { value: 'HFSA', label: 'HFSA' },
  { value: 'MFIORE', label: 'MFIORE' },
  { value: 'AHA', label: 'AHA' },
  { value: 'UAB', label: 'UAB' },
  { value: 'STANFORD', label: 'STANFORD' },
  { value: 'LIFESPAN', label: 'LIFESPAN' },
  { value: 'POPULACE', label: 'POPULACE' },
  { value: 'CHS', label: 'GRANDVIEW' }
]
const ecogFormOptions = [
  { value: '1', label: 'ECOG 0,1' },
  { value: '2', label: 'ECOG 2' },
  { value: '3', label: 'ECOG 3' },
  { value: '4', label: 'ECOG 4' }
]

const prevTreatment = [
  {value: '1', label: 'Yes',color: '#444'},
  {value: '0',label: 'No',color: '#444'}
]

const customStyles = {
  container: (provided) => ({
    ...provided,
    display: 'inline-block',
    minWidth: '200px',
    minHeight: '1px',
    textAlign: 'left',
    border: 'none',
  }),
  control: (provided) => ({
    ...provided,
    cursor:'pointer',
    minHeight: '30px',
    borderRadius: 2
  }),
  input: (provided, state) => ({
    ...provided,
    minHeight: '1px',
    borderColor: state.isFocused ? 'red' : 'none'
  }),
  valueContainer: (provided) => ({
    ...provided,
    minHeight: '25px',
    paddingTop: '0',
    paddingBottom: '0',
  }),
  menu: provided => ({
    ...provided,
    zIndex: 25
  }),
  multiValueLabel: provided => ({
    ...provided,
    height: 20,
    padding:1.5
  }),
  multiValueRemove: provided => ({
    ...provided,
    height: 22
  }),
  option: (provided, { data, isFocused, isSelected }) => ({
    ...provided,
    height: 30,
    zIndex: 999,
    fontSize: 16,
    cursor: 'pointer',
    color: isFocused || isSelected ? 'white' : data.color
  }),
  multiValue: provided => ({
    ...provided,
    height: 22,
    fontSize: 16,
    minHeight: '1px',
    paddingBottom: '2px',
    paddingTop: 0
  }),
  singleValue: (provided) => ({
    ...provided,
    height: 20,
    fontSize: 16,
    minHeight: '1px',
    paddingBottom: '2px',
    paddingTop: 0
  })
};
const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 5,
  width: 210,
  colors: {
    ...theme.colors,
    text: 'white',
    primary25: 'rgba(68, 84, 97,.8)',
    primary: '#445461'
  },
  spacing: {
    controlHeight: 20,
    menuGutter: 1,
    baseUnit: 2
  }
})

let ageItems = [{ value: '<1', label: 'Under 1', color: '#444' }]
for (var i = 1; i < 76; i++) {
  ageItems.push({ value: i, label: i, color: '#444' })
}

ageItems.push({ value: '>75', label: 'Over 75', color: '#444' })

const colorCodeTriage = {
  'Inbox': '#4682b4',
  'Pre Screen Pass': '#659157',
  'Pre Screen Fail': '#e74c3c',
  'Deleted': '#d39151',
  'Patient Contacted': '#533a71'
}

const returnFilterLabel = (data, label) => {
  let returnLabel = data;

  if(label === 'recurrent') parseInt(data) === 0 ? returnLabel = 'No' : returnLabel = 'Yes'
  if(label === 'pscore') parseInt(data) === 1 ? returnLabel = 'ECOG 0,1' : returnLabel = 'ECOG '+data


  return returnLabel
}

export const selectSettings = {
  inboxOptions,
  customStyles,
  trialStatus,
  genderPatient,
  returnFilterLabel,
  ecogFormOptions,
  studyType,
  prevTreatment,
  studyPhase,
  ageItems,
  gender,
  healthy,
  instances,
  colorCodeTriage,
  selectTheme
}
